import useCountUpScore from './useCountUpScore'

const Group = ({ group, animationDelay = 0.3 }) => {
  const score = useCountUpScore(group.score);

  return (
        <span className="leaderboard-points">{score}</span>
  );
};

export default Group
